import React, { useMemo } from "react";
import { Scatter } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

function ScatterChart(props) {
  const { data } = props;
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Quota Attainment",
          font: {
            size: 18,
            family: "neuehaas",
          },
        },
        // suggestedMax: 100,
        max: data?.graphBounds?.y || 100,
        grid: {
          color: (ctx) => (ctx.tick.value === 100 ? "#ccc" : "#fff"),
          lineWidth: (ctx) => (ctx.tick.value === 100 ? 2 : 1),
          borderDash: [8, 8],
        },
        min: 0,
        ticks: {
          callback: (value) => `${value}%`,
          color: (ctx) => {
            if ((ctx.tick.value / 10) % 2 > 0) return "#fff";
            return ctx.tick.value === 100 ? "green" : "#aaa";
          },
          font: {
            size: (ctx) => {
              try {
                return ctx.tick.value === 100 ? 16 : 12;
              } catch {
                return 12;
              }
            },
            weight: (ctx) => {
              try {
                return ctx.tick.value === 100 ? 600 : 400;
              } catch {
                return 400;
              }
            },
          },
        },
      },
      x: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Average Daily Points",
          font: {
            size: 18,
            family: "neuehaas",
          },
        },
        // suggestedMax: 10,
        max: data?.graphBounds?.x || 10,
        min: 0,
        ticks: {
          // callback: (value) => (value === 10 ? value : ""),
          color: (ctx) => {
            if (ctx.tick.value % 2 > 0) return "#fff";
            return ctx.tick.value === 10 ? "green" : "#aaa";
          },
          font: {
            size: (ctx) => {
              try {
                return ctx.tick.value === 10 ? 16 : 12;
              } catch {
                return 12;
              }
            },
            weight: (ctx) => {
              try {
                return ctx.tick.value === 10 ? 600 : 400;
              } catch {
                return 400;
              }
            },
          },
        },
        grid: {
          color: (ctx) => {
            if (ctx.tick.value % 2 > 0 || ctx.tick.value === 0) return "#fff";
            return ctx.tick.value === 10 ? "#ccc" : "#ddd";
          },
          lineWidth: (ctx) => (ctx.tick.value === 10 ? 2 : 1),
          borderDash: [8, 8],
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: "Skill vs Will",
        font: {
          size: 24,
          family: "neuehaas",
        },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            let user = ctx?.dataset?.labels?.[ctx.dataIndex]?.toString?.();

            if (!user) {
              return "";
            }

            user =
              user.length <= 3
                ? user
                : user
                    .split(" ")
                    .map((item) => item[0])
                    .join("");
            return `${user} - Points: ${ctx.parsed.x}, Attainment: ${ctx.parsed.y}%`;
          },
          afterBody: (ctx) => {
            const teams = [];
            const reportsTo = [];
            ctx.forEach((c) => {
              if (c.raw.team && teams.indexOf(c.raw.team) < 0) teams.push(c.raw.team);
              if (c.raw.reportsTo && reportsTo.indexOf(c.raw.reportsTo) < 0)
                reportsTo.push(c.raw.reportsTo);
            });
            let text = "";
            if (teams.length) text += `Team: ${teams.join(", ")}`;
            if (reportsTo.length) {
              if (text.length) text += "\n";
              text += `Reports To: ${reportsTo.join(", ")}`;
            }
            return text;
          },
          title: (ctx) => {
            let title = "";
            ctx.forEach((c, i) => {
              if (i > 0) title += "\n";
              title += `${c?.dataset?.labels?.[c.dataIndex] || ""}`;
            });
            return title;
          },
          labelPointStyle: () => ({
            pointStyle: "circle",
          }),
          labelTextColor: () => "#333333",
        },
        usePointStyle: true,
        position: "nearest",
        mode: "point",
        intersect: true,
        yPadding: 10,
        xPadding: 10,
        caretSize: 9,
        caretPadding: 10,
        backgroundColor: "white",
        bodyColor: "#000",
        bodyFontColor: "#000",
        borderColor: "#888",
        borderWidth: 1,
        // yAlign: "bottom",
        titleColor: "black",
        footerColor: "black",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        color: "white",
        font: {
          weight: "bold",
        },
        formatter: (value) => {
          try {
            if (value.label.length <= 2) return value.label;
            return value.label
              .split(" ")
              .map((item) => item[0])
              .join("");
          } catch {
            return "";
          }
        },
        offset: 2,
        padding: 0,
      },
    },
  };

  return useMemo(
    () => <Scatter data={data.chartData} options={options} plugins={[ChartDataLabels]} />,
    [data]
  );
  // return <Scatter data={data} options={options} />;
}

export default ScatterChart;
